<template>
  <div class="flex flex-col my-10">
    <div
      class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
    >
      <h3 class="mt-10 mb-5 w-full">
        Droits restreints
      </h3>
      <h6 class="text-gray-600">
        Vous n’avez pas les droits nécessaires pour accéder à cette page.
      </h6>
      <h6 class="text-gray-600">
        Pour les obtenir, vous devez les demander à {{ hostname == null ? "l’administrateur de votre structure" : hostname }}.
      </h6>

      <div class="flex items-center justify-center mt-15">
        <illustration name="notAllowed" />
      </div>
      <div
        v-if="!$isGuest()"
        class="flex items-center justify-center mt-15 mb-15"
      >
        <router-link :to="{ name: 'Dashboard' }">
          <action-button 
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Revenir à l'accueil"
            :uppercase="true"
            icon="home"
            type-shadow="shadow-pink"
            :enable-action="false"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Illustration from './Illustration';
import ActionButton from './ActionButton';
export default {
  components:{
    Illustration,
    ActionButton
  },

  props:{
    hostname:{
      type: String,
      required: false,
      default: null,
    }
  }
};
</script>